import React, {useState} from 'react';
import {Map} from '../components';
import { useTranslation } from 'react-i18next';
import {Badge, Col, Row} from "react-bootstrap";
import BlockTable from "../BlockTable";
import {AdminBoundariesToArray} from "../../services/zones";
import Table from "../tables/Table";
import useCustomTable from "../tables/useCustomTable";


function AdminBoundariesFilter({value, disabled}) {
  const [selected, setSelected] = useState(AdminBoundariesToArray(value))
  const [tableRowHighlighted, setTableRowHighlighted] = useState(null);
  const [mapHovered, setMapHovered] = useState(null);
  const { t } = useTranslation();

  const columns = [{
      Header: 'Name',
      accessor: 'name',
      Cell: (cell, row) => {
        if (cell.row.original.level == 0) {
          return String(t("countries."+cell.row.original.value))
        } else {
          return <div>
            {String(cell.value)}<br/>
            <b>{String(t("countries."+cell.row.original.country))}</b>
          </div>
        }
      }
    },{
      Header: 'Level',
      accessor: 'level',
      Cell: (cell) => <Badge pill variant="primary">{`level ${cell.value}`}</Badge>
    }
  ]

  const tableOptions = {
    sortable: true,
    filterable: false,
    paginate: true,
    header: true
  }

  const handleRowHover = (row) => setMapHovered(row ? {value: row.value, level: row.level} : null)

  const handleMapHover = (feature) => {
    if (feature) {
      const index = selected.findIndex(x => x.value == feature.value && x.level == feature.level)
      setTableRowHighlighted(index >= 0 ? index : null)
    }
  }

  const heightStyle = {
    height: '500px',
    marginBottom: '30px'
  }

  const {
    tableProps,
    paginationProps,
    tableSearchProps,
    tablePageLengthProps
  } = useCustomTable()

  return (
    <Row>
      <BlockTable as={Col} md={12} lg={6} fullHeight style={{maxHeight: '500px'}}>
        <Table
          data={selected}
          columns={columns}
          {...tableOptions}
          {...tableProps}
          highlighted={tableRowHighlighted}
          onRowHover={handleRowHover}
          hiddenColumns={disabled ? ['id'] : []} />
      </BlockTable>
      <Col md={12} lg={6} style={heightStyle}>
        <Map
          interactiveLayer={['countries', 'regions', 'departments', 'cities', 'iris'][0]}
          selected={selected}
          hovered={mapHovered}
          onHover={handleMapHover}
          disabled={true}
        />
      </Col>
    </Row>
  )
}

export default AdminBoundariesFilter
